import {
    collection, deleteDoc, doc, DocumentData, getDocs, query,
    serverTimestamp, setDoc, where, updateDoc
} from "firebase/firestore";
import { firestore } from '../utils/Firebase';

const store = firestore();
const collectionRef = collection(store, 'clientpartners');

export const AddClientPartners= async (values: any) => {
    const id = `CP-${Math.random().toString(10).slice(12).toUpperCase()}`;
    console.log(collectionRef.id);
    const q = query(collectionRef, where("name", "==", values.name));
    const dataToCreate = {
        ...values,
        id: id,
        createTimestamp: serverTimestamp(),
        updateTimestamp: serverTimestamp()
    }
    const docs = await getDocs(q);
    if (docs.size > 0) {
        return { code: 400, message: 'Client or Partners already exist' }
    } else {
        await setDoc(doc(collectionRef, id), dataToCreate);
        return { code: 200, message: 'Client or Partners added successfully' }
    }

}

export const GetClientPartners = async () => {
    let clientPartnerList: DocumentData[] = [];
    const clientPartners = await getDocs(collectionRef);
    clientPartners.forEach(
        res => clientPartnerList.push(res.data())
    )
    return clientPartnerList;
}

export const DeleteClientPartners = async (selectedID: string[]) => {
    const q = query(collectionRef, where('id', 'in', selectedID));
    const res = await getDocs(q);
    res.forEach(async doc => await deleteDoc(doc.ref));
    return { code: 200, message: 'Client or Partner deleted successfully' }
}

export const UpdateClientPartners= async (values: any) => {
    const docRef = doc(collectionRef, values.id)
    await updateDoc(docRef, values);
    return { code: 200, message: 'Client or Partner updated successfully' }
}
